<template>
  <div>
    <p>Still organized</p>
  </div>
</template>

<script>

export default{
  name: 'stuff-page'
}

</script>



// WEBPACK FOOTER //
// StuffPage.vue?8f4a3918